<template>
    <v-layout>
        <div class="col-12">
            <v-toolbar flat>
                <v-toolbar-title>{{ $t('manual_transfer') }}</v-toolbar-title>
                <template v-slot:extension>
                    <v-tabs
                            v-model="tab"
                            align-with-title
                    >
                        <v-tabs-slider color="primary"></v-tabs-slider>
                        <v-tab>{{ $t('transfer_limb') }}</v-tab>
                        <v-tab>{{ $t('transfer_log') }}</v-tab>
                    </v-tabs>
                </template>
            </v-toolbar>
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-card>
                        <redeemlogtable v-if="tab==0" mode="inprogress"/>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card>
                        <redeemlogtable v-if="tab==1" mode="all"/>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </div>
    </v-layout>
</template>
<script>
    import RedeemLogTable from "@/views/RedeemLogTable";
    export default {
        components: {
            redeemlogtable: RedeemLogTable,
        },
        name: "RedeemLogWrapper",
        data: () => ({
            loading: false,
            tab: null,
        })
    }
</script>
